module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Buel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Richard Buel")]), _vm._v(" is Professor of History Emeritus at Wesleyan University. He is author of several books, including "), _c('I', [_vm._v("In Irons: Britain's Naval Supremacy and the American Revolutionary Economy")]), _vm._v(". He lives in Essex, Connecticut.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oZTPxX/tc-custom/9781250106544.jpg?1731182959754",
      "alt": "This image is the cover for the book America on the Brink"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("America on the Brink\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v(" The fascinating story of how New England Federalists threatened to  dissolve the Union by making a separate peace with England during the  War of 1812. ")]), _c('br'), _c('br'), _vm._v("Many people would be surprised to learn that the struggle between Thomas Jefferson's Republican Party and Alexander Hamilton's Federalist Party defined--and jeopardized--the political life of the early American republic. Richard Buel Jr.'s "), _c('i', [_vm._v("America on the Brink")]), _vm._v(" looks at why the Federalists, who worked so hard to consolidate the federal government before 1800, went to great lengths to subvert it after Jefferson's election. In addition to taking the side of the British in the diplomatic dance before the war, the Federalists did everything they could to impede the prosecution of the war, even threatening the Madison Administration with a separate peace for New England in 1814. "), _c('br'), _c('br'), _vm._v("Readers fascinated by the world of the Founding Fathers will come away from this riveting account with a new appreciation for how close the new nation came to falling apart almost fifty years before the Civil War.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press Griffin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0